/**
 * Backwards-compatible re-exports. The real values now live in
 * src/config/env.js. New code should import `API` directly; this shim exists
 * so that older imports keep working.
 */
import { API } from "../config/env";

export const BASE_URL = API.PLATFORM;
export const SERVICE_URL = API.SERVICE;
export const NEW_SERVICE_URL = API.CONVERSATION;
